
import { connect } from 'react-redux';
import React, {useState} from 'react'
import { useAlert } from 'react-alert'

import * as actions from '../../store/actions';
import * as ROUTES from '../../constants/routes'
import Button from '../Button'
import checkValidity from '../../util/validation';
import Form from '../Form';

import styles from './PasswordReset.module.css';
import ContentWrapper from '../ContentWrapper';
import Title from '../Title';

const PasswordReset = props => {

  const [controls, setControls] = useState({
    email: {
      order: 0,
      elementType: 'input',
      elementConfig: {
        type: 'email',
        placeholder: 'Email'
      },
      value: '',
      validation: {
        required: true,
        isEmail: true,
        isUCSFemail: true
      },
      valid: false,
      touched: false
    }
  });

  const changeHandler = (event, id) => {
    const updatedControls = {
      ...controls,
      [id]: {
        ...controls[id],
        value: event.target.value,
        valid: checkValidity(event.target.value,controls[id].validation),
        touched: true
      }
    }
    setControls( updatedControls )
  }

  const alert = useAlert()

  const submitHandler = (event) => {
    event.preventDefault();

    if (!controls.email.valid) {
      alert.error('Email must your valid ucsf.edu address')
    } else {
      props.resetPassword({
        email: controls.email.value.toLowerCase(),
      })
      props.history.push(ROUTES.LANDING)
    }
  }

  return (
    <ContentWrapper>
      <div className={styles.PasswordReset}>
        <Title>Reset Password</Title>
        <p>Forget your password? Enter the email associated with your account and a password reset email will be emailed back to you.</p>
        <Form className={styles.Form} 
          controls={controls}
          changeHandler={changeHandler}
          submitHandler={submitHandler}
          submitName="Reset Password"
        />
        <Button className='gray' style={{marginTop:"1rem"}} onClick={()=> props.history.push(ROUTES.LANDING)}>Cancel</Button>
      </div>
    </ContentWrapper>
  )
}

const mapDispatchToProps = dispatch => {
  return {
    resetPassword: (payload) => dispatch(actions.resetPassword(payload))
  }
}

export default connect(null,mapDispatchToProps)(PasswordReset)